export enum CalendarErrorType {
	CREATE_FAILED = "CREATE_FAILED",
	UPDATE_FAILED = "UPDATE_FAILED",
}
